import React from "react";
import { getClassName } from "@sscs/utils";
import { CheckIcon, DownloadIcon, HighlightOffIcon, InfoIcon, UploadIcon, WarningOutlineIcon, } from "../../icons";
import Link from "../Link/Link";
import styles from "./toast.module.scss";
const CHIP_BY_TYPE = {
    error: {
        Glyph: HighlightOffIcon,
        color: "danger",
        className: styles["chip-error"],
    },
    warning: {
        Glyph: WarningOutlineIcon,
        color: "warning",
        className: styles["chip-warning"],
    },
    success: {
        Glyph: CheckIcon,
        color: "success",
        className: styles["chip-success"],
    },
    info: { Glyph: InfoIcon, color: "info", className: styles["chip-info"] },
};
const CHIP_BY_KIND = {
    upload: {
        Glyph: UploadIcon,
        color: "interactive",
        className: styles["chip-progress"],
    },
    export: {
        Glyph: DownloadIcon,
        color: "interactive",
        className: styles["chip-progress"],
    },
    info: {
        Glyph: InfoIcon,
        color: "interactive",
        className: styles["chip-progress"],
    },
};
const Action = ({ action, closeToast, }) => {
    const { label, onClick, to, href, variant = "primary", disabled } = action;
    const className = getClassName(styles.action, variant === "secondary" ? styles["action-secondary"] : undefined);
    const run = () => {
        onClick === null || onClick === void 0 ? void 0 : onClick();
        if (action.closeOnClick !== false)
            closeToast === null || closeToast === void 0 ? void 0 : closeToast();
    };
    if (to !== undefined || href !== undefined) {
        return (React.createElement(Link
        // eslint-disable-next-line @typescript-eslint/no-explicit-any -- to/href are mutually exclusive at the callsite; the Link union can't narrow here.
        , { ...{ to, href }, inline: true, underline: "hover", className: className, onClick: run }, label));
    }
    return (React.createElement("button", { type: "button", className: className, disabled: disabled, onClick: run }, label));
};
const ToastCard = ({ title, description, actions, type = "default", progressKind, percent, closeToast, }) => {
    const chip = progressKind ? CHIP_BY_KIND[progressKind] : CHIP_BY_TYPE[type];
    return (React.createElement("div", { className: styles.card },
        chip && (React.createElement("div", { className: getClassName(styles.chip, chip.className) },
            React.createElement(chip.Glyph, { size: "sm", color: chip.color }))),
        React.createElement("div", { className: styles.content },
            React.createElement("div", { className: styles.title }, title),
            description !== undefined && description !== null && (React.createElement("div", { className: styles.description }, description)),
            actions && actions.length > 0 && (React.createElement("div", { className: styles.actions }, actions.map((action, index) => (React.createElement(Action, { key: index, action: action, closeToast: closeToast })))))),
        percent !== undefined && (React.createElement("div", { className: styles.percent },
            Math.round(percent),
            "%"))));
};
export default ToastCard;
//# sourceMappingURL=ToastCard.js.map